import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useAuthCallback } from './hooks';

const AuthLink = React.forwardRef(({ onClick, ...props }, ref) => {
  const authCallback = useAuthCallback();
  const clickHandler = (event) => {
    if (typeof onClick === 'function') {
      onClick(event);
    }
    authCallback(event);
  };

  return <Link ref={ref} {...props} onClick={clickHandler} />;
});

AuthLink.propTypes = {
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.func])
    .isRequired,
  onClick: PropTypes.func,
};

export default AuthLink;
